import gql from 'graphql-tag';

export const GetApplicationPaymentByIdQuery = gql`
  query GetApplicationPaymentByIdQuery($applicationId: String) {
    applicationPayment(applicationId: $applicationId) {
      id
      _Ebb_ApplicationId
      _Ebb_AchPaymentId
      w9FullName
      w9AddressStreet
      w9AddressCity
      w9AddressState
      w9AddressZip
      w9AuthorizationDate
      w9SsnLast4
      pafFullName
      pafTypeCode
      pafAddressStreet
      pafAddressCity
      pafAddressState
      pafAddressZip
      pafAuthorizationDate
      pafSsnLast4
      pafPaymentTypeCode
    }
  }
`;